module.exports = __webpack_public_path__ + "static/together_event01_img-0ef625f478825e516c7fbc2e247852b6.png";